  <template>

    <div class="mobile">
      
      <a id="mobile_icon" @click="toggleMenu">
        <i class="fas fa-bars" v-if="is_open==false"></i>
        <i class="fas fa-times-circle" v-if="is_open==true"></i>
      </a>

      <nav class="nav-drill">
        <ul class="nav-items nav-level-1">

          <li v-for="(page,index) in $t('pages_')" v-if="page.key!=undefined && page.hide!=true" v-bind:key="page.key" :class="'nav-item '+page.class">
            <router-link :to="$i18nRoute({ name: page.route })" @click.native="navigateMobile" class="nav-link">
              {{ page.name }}
            </router-link>
          </li>

        </ul>
      </nav>
  </div>

</template>

<script>
import { Trans } from '@/plugins/Translation'

export default {
  props : {
    is_home : "" 
  } , 

  data : ()=>{
    return {
      is_open : false
    }
  },
  mounted(){

    this.is_open = $('.mobile').hasClass('nav-is-toggled') ; 
  },
  computed: {
  },
  methods: {

    /**
    * Toggling menu
    * @param (no param)
    */
    toggleMenu : function(){
      
      $('.mobile').toggleClass('nav-is-toggled');
      $('.page').toggleClass('is_mobile');
      this.is_open = !this.is_open ; 

    },

    navigateMobile : function(){
      $('.mobile').removeClass('nav-is-toggled');
      $('.page').removeClass('is_mobile');
      this.is_open = false ; 
    }
  }
}
</script>

<style lang="scss">
/* Mobile */

@use "sass:color";

$black: #252525;
$white: #fff;
$grey: #eaeaea;

$primary-color: #1E7FB8;
$color : #1E7FB8;
$primary-color-dark: #000000 ; 

/*$primary-color-dark: color.adjust( $primary-color, 10% );
$primary-color-tint-1: color.adjust( $primary-color, 10% );
$primary-color-tint-2: color.adjust( $primary-color, 20% );
$primary-color-tint-3: color.adjust( $primary-color, 30% );
$primary-color-tint-4: color.adjust( $primary-color, 40% );
$primary-color-tint-5: color.adjust( $primary-color, 50% );*/

$primary-font: "Fira Sans", Arial, sans-serif;
$link-color: $primary-color;

// ---------------------------------------
// important stuff starts here

$nav-width: 250px;
$nav-padding: 0.875em 1em;
$nav-border-color: $primary-color-dark ;
$nav-background-color: $white;
$nav-icon-font: 'Material Icons';
$nav-icon-arrow-right: 'chevron_right';
$nav-icon-arrow-left: 'chevron_left';

$nav-level-border-color: $primary-color;

$nav-level-background-color:  $primary-color-dark ;

/*$nav-level3-background-color: $primary-color-tint-4;
$nav-level4-background-color: $primary-color-tint-3;
$nav-level5-background-color: $primary-color-tint-2;*/

a#mobile_icon{
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 999;
  cursor: pointer;
  i.fa-bars{
    color: #fff ;
    font-size: 2em;
  }
  i.fa-times-circle{
    color: $primary-color ;
    font-size: 2em;
  }
}

.page{
  opacity: 1;
  &.is_mobile{
    opacity: 0.2 ; 
  }
}

.mobile{
  display: none;
} 

// mixin for-tablet-portrait-up {
@media (max-width: 1200px) { 

  .mobile{
    display: block ; 
    .nav-top {
      display: flex;
      align-items: center;
      position: fixed;
      z-index: 101;
      padding: 10px 20px;
      width: 100%;
      height: 0px;
      background-color: $primary-color-dark;
       
      .hamburger {
        margin-left: auto;
        color: $white;
        cursor: pointer;
      }
    }
    .nav-drill {
      margin-top: 0px;
      /*transform: translateX(100%);*/
      box-shadow: 2px 2px 10px 3px rgba(0, 0, 0, 0.3);
    }

    &.nav-is-toggled {
      &::after {
        opacity: 1;
        visibility: visible;
      }
      .nav-drill {
        /*transform: translateX(0);
        -webkit-transform: translateX(-150px);*/
        /*transform: translateX(-150px);*/
        right: 0px;
      }
    }

    

    .nav{
      &-drill {
        display: flex;
        position: fixed;
        z-index: 100;
        top: 0;
        right: -250px;
        width: $nav-width;
        height: 100vh;
        background-color: $nav-background-color;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        transition: 0.45s;
      }
      
      &-items {
        flex: 0 0 100%;
        margin-top: 10px;
        padding-left: 5px;
      }
      
      &-item {
        &:not(:last-child) {
          border-bottom: solid 1px $nav-border-color;
        }
      }
      
      &-link {
        display: block;
        padding: $nav-padding;
        background-color: $nav-background-color;
        color: $link-color;
        font-size: 1rem;
        line-height: 1.5em;
        font-weight: 800;
        text-align: left;
        &:hover{
          background-color: #ededed; 
        }
      }
      
      &-expand {
        &-content {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          transform: translateX(100%);
          background-color: $nav-level-background-color;
          transition: 0.3s;
          visibility: hidden;
          
          .nav-item {
            &:not(:last-child) {
              border-bottom: solid 1px $nav-level-border-color;
            }
          }

          .nav-link {
            font-weight: 800;
            text-align: left;
          }
        }
        
      
        &.active {
          > .nav-expand-content {
            transform: translateX(0);
            visibility: visible;
          }
        }
          
      }
    }
  }
}

.mobile{
  .nav-item.disabled{
    a.nav-link{
      cursor: not-allowed ;
      color: #ccc !important ; 
    }
  }
}


</style>